module.exports = __webpack_public_path__ + "static/v4-a493916f2a05329433bf20bab0a134a7.jpg";